import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [-11.647164, 166.939125, 2.4],
  [-11.647106, 166.93901, 2.4],
  [-11.647035, 166.9389, 2.4],
  [-11.646964, 166.938789, 2.4],
  [-11.646897, 166.938678, 2.4],
  [-11.646831, 166.938569, 2.4],
  [-11.646765, 166.938462, 2.4],
  [-11.646698, 166.938356, 2.4],
  [-11.646632, 166.938251, 2.4],
  [-11.646568, 166.938146, 2.4],
  [-11.646506, 166.938042, 2.4],
  [-11.646443, 166.937939, 2.4],
  [-11.646373, 166.937837, 2.4],
  [-11.6463, 166.937744, 2.4],
  [-11.646213, 166.937661, 2.4],
  [-11.646114, 166.937595, 2.4],
  [-11.646012, 166.937534, 2.4],
  [-11.645918, 166.937464, 2.4],
  [-11.645839, 166.937376, 2.4],
  [-11.645779, 166.937275, 2.2],
  [-11.645736, 166.937165, 2.2],
  [-11.645706, 166.937052, 2.2],
  [-11.64568, 166.936935, 2.2],
  [-11.645656, 166.936821, 2.2],
  [-11.645631, 166.936708, 2.2],
  [-11.6456, 166.936597, 2.2],
  [-11.64556, 166.936487, 2.2],
  [-11.645509, 166.936383, 2.2],
  [-11.645444, 166.936287, 2.2],
  [-11.645365, 166.936203, 2.2],
];

export default stream;
